import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { OrderedBulletGroup } from "../../../components/ordered-bullet-group";

export interface INextProps {
    sectionId: string;
    index: number;
}

export function Next(props: INextProps) {
    const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
    return (
        <Section
            sectionId={props.sectionId}
            isLast={false}
        >
            <SectionHeader
                title={`${formattedIndex} Definiton`}
            />
            <ParagraphGroup
                body={[
                    "As we began to brainstorm potential solutions, we identified two core user goals that AI could help meet:"
                ]}
            />
            <OrderedBulletGroup
                bullets={[
                    "Facilitate quick evaluations of credibility at the speed users scroll",
                    "Help users understand and reflect on how they spend their time on social platforms to promote behavior change"
                ]}
            />
            <ParagraphGroup
                body={[
                    "With these considerations in mind, we began to craft our vision for the future of misinformation mitigation."
                ]}
            />
        </Section>
    );
}
